import { List, Datagrid, TextField, DateField, SimpleList, ShowButton, ReferenceField } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { careerCenterRequests } from "api/careerCenterApi";
import { MobileListRow } from "features/MobileListRow";

const ListJobs = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  return (
    <List exporter={false}>
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              style={{ marginRight: 16 }}
              fields={[{ label: "Позиция", value: record.title }]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: (
                      <ReferenceField
                        label="Статус"
                        source="status"
                        reference={careerCenterRequests.getStatusesSelect()}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Публикувана до",
                    value: (
                      <DateField
                        source="validUntil"
                        label="Публикувана до"
                        locales="bg-BG"
                        showTime
                        sortable="false"
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => <ShowButton label="" />}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="title"
            label="Позиция"
            sortable="false"
          />
          <ReferenceField
            label="Статус"
            source="status"
            reference={careerCenterRequests.getStatusesSelect()}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <DateField
            source="validUntil"
            label="Публикувана до"
            locales="bg-BG"
            showTime
            sortable="false"
          />
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListJobs;
